import {gql} from "@irati/utils/gql"

const fragment = gql`
  fragment adyenProcessedPayment on AdyenProcessedPayment {
    additionalData {
      recurringProcessingModel
    }
    merchantReference
    pspReference
    resultCode
    action
  }
`

export const toString = fragment.loc.source.body

export default fragment
